'use strict';

import angular from 'angular';
import ngCookies from 'angular-cookies';
import uiRouter from 'angular-ui-router';

// import angularRaven from 'exports-loader?\'ngRaven\'!angular-raven';

import constants from '../constants';
import models from '../models';

import slideshow from '../common/slideshow';

import accountActivationModal from './account_activation_modal';
import autocompleteService from './autocomplete_service';
import activateGuideAccount from './activate_guide_account';
import admin from './admin';
import alert from './alert';
import analytics from './analytics';
import analyticsSa from './analytics_sa';
import auth from './auth';
import authInterceptor from './auth_interceptor';
import becomeGuide from './become_guide';
import bodyElement from './body_element';
import breakpoint from './breakpoint';
import calendar from './calendar';
import config from './config';
import contact from './contact';
import cookieStorage from './cookie_storage';
import bodyScroll from './body_scroll';
import development from './development';
import deviceCapabilities from './device_capabilities';
import facebook from './facebook';
import favicon from './favicon';
import featuredGuides from './featured_guides.service';
import fetchProfile from './fetch_profile';
import generationTime from './generation_time';
import googleMapsLoader from './google_maps_loader';
import guideSearchFilters from './guide_search_filters.service';
import guideStatus from './guide_status';
import imgixHelpers from './imgix_helpers';
import join from './join';
import joinFbLanding from './join_fb_landing';
import jsLoader from './js_loader';
import lastBookingInfo from './last_booking_info';
import lazysizes from './lazysizes';
import localStorage from './local_storage';
import logout from './logout';
import marketingId from './marketing_id';
import membership from './membership';
import messenger from './messenger';
import modal from './modal';
import objectToArray from './object_to_array';
import navigation from './navigation';
import notification from './notification';
import password from './password';
import payments from './payments.service';
import paymentsSubscription from './payments_subscription.service';
import paymentsBooking from './payments_booking.service';
import placesService from './places_service';
import preventClick from './prevent_click';
import rateService from './rate_service';
import realtime from './realtime';
//import recurringMessenger from './recurring_messenger';
import reloadPage from './reload_page';
import resolveTemplate from './resolve_template';
import resource from './resource';
import reviews from './reviews';
import scrollTop from './scroll_top';
import scrollbarWidth from './scrollbar_width';
import session from './session';
import settings from './settings';
import settingsLayoutConfig from './settings_layout_config';
import shuffleService from './shuffle.service';
import socialShare from './social_share';
import sounds from './sounds';
import social from './social';
import specialCurrencies from './special_currencies';
import stopRemarketing from './stop_remarketing';
import Storage from './storage';
import temporaryUser from './temporary_user';
import testUsers from './test_users';
import throttle from './throttle';
import tracking from './tracking';
import title from './title';
import unreadConversationIds from './unread_conversation_ids';
import uploadPhoto from './upload_photo';
import userInteraction from './user_interaction';
import utils from './utils';
import vk from './vk';
import referenceCheck from './reference_check';
// import ravenM from './raven_m';
import conversationsFetching from './conversations_fetching';
import report from './report.service';
import listingPrice from './listing_price';
//import appBanner from './app_banner';
import appBecomeGuideBanner from './app_become_guide_banner';
import meta from './meta';
import deslug from './deslug';
import slug from './slug';

const dependencies = [
  ngCookies,
  uiRouter,
  constants,
  models,
  slideshow
];

export default angular.module('services', dependencies)
  .factory('autocompleteService', autocompleteService)
  .factory('accountActivationModal', accountActivationModal)
  .factory('activateGuideAccount', activateGuideAccount)
  .factory('admin', admin)
  .factory('alert', alert)
  .factory('analytics', analytics)
  .factory('analyticsSa', analyticsSa)
  .factory('auth', auth)
  .factory('authInterceptor', authInterceptor)
  .factory('becomeGuide', becomeGuide)
  .factory('bodyElement', bodyElement)
  .factory('breakpoint', breakpoint)
  .factory('calendar', calendar)
  .constant('config', config)
  .factory('contact', contact)
  .factory('cookieStorage', cookieStorage)
  .factory('bodyScroll', bodyScroll)
  .factory('development', development)
  .factory('deviceCapabilities', deviceCapabilities)
  .factory('facebook', facebook)
  .factory('favicon', favicon)
  .factory('featuredGuides', featuredGuides)
  .factory('fetchProfile', fetchProfile)
  .factory('generationTime', generationTime)
  .factory('googleMapsLoader', googleMapsLoader)
  .service('guideSearchFilters', guideSearchFilters)
  .factory('guideStatus', guideStatus)
  .factory('imgixHelpers', imgixHelpers)
  .factory('join', join)
  .factory('joinFbLanding', joinFbLanding)
  .factory('jsLoader', jsLoader)
  .factory('lastBookingInfo', lastBookingInfo)
  .factory('lazysizes', lazysizes)
  .factory('localStorage', localStorage)
  .factory('logout', logout)
  .factory('marketingId', marketingId)
  .factory('membership', membership)
  .factory('messenger', messenger)
  .factory('modal', modal)
  .factory('objectToArray', objectToArray)
  .factory('navigation', navigation)
  .factory('notification', notification)
  .factory('password', password)
  .factory('payments', payments)
  .factory('paymentsSubscription', paymentsSubscription)
  .factory('paymentsBooking', paymentsBooking)
  .service('placesService', placesService)
  .factory('preventClick', preventClick)
  .factory('rateService', rateService)
  .factory('realtime', realtime)
  //.factory('recurringMessenger', recurringMessenger)
  .factory('reloadPage', reloadPage)
  .factory('resolveTemplate', resolveTemplate)
  .provider('resource', resource)
  .factory('reviews', reviews)
  .factory('scrollTop', scrollTop)
  .factory('scrollbarWidth', scrollbarWidth)
  .factory('session', session)
  .factory('settings', settings)
  .factory('settingsLayoutConfig', settingsLayoutConfig)
  .factory('shuffle', shuffleService)
  .factory('socialShare', socialShare)
  .factory('sounds', sounds)
  .factory('social', social)
  .value('specialCurrencies', specialCurrencies)
  .factory('stopRemarketing', stopRemarketing)
  .factory('Storage', Storage)
  .factory('temporaryUser', temporaryUser)
  .factory('testUsers', testUsers)
  .factory('throttle', throttle)
  .factory('tracking', tracking)
  .factory('title', title)
  .factory('unreadConversationIds', unreadConversationIds)
  .factory('uploadPhoto', uploadPhoto)
  .factory('userInteraction', userInteraction)
  .factory('utils', utils)
  .factory('vk', vk)
  .factory('referenceCheck', referenceCheck)
  // .factory('ravenM', ravenM)
  .value('conversationsFetching', conversationsFetching)
  .factory('report', report)
  .value('listingPrice', listingPrice)
  //.factory('appBanner', appBanner)
  .factory('appBecomeGuideBanner', appBecomeGuideBanner)
  .factory('meta', meta)
  .factory('deslug', deslug)
  .factory('slug', slug)
  .name;



// WEBPACK FOOTER //
// ./app/src/services/index.js